var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Stacker, TypographyHeading } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
export function HotelRoomsHeading(_a) {
    var other = __rest(_a, []);
    const { resourceStrings: { HOTEL_ROOM_HEADING }, } = useGlobalContext();
    return (React.createElement(Stacker, Object.assign({ spacing: 2 }, other),
        React.createElement(TypographyHeading, { size: "s", color: "text.body", "data-id": "rooms-section-heading" }, HOTEL_ROOM_HEADING)));
}
